import { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { buildReportPdf, downloadBlob, reportFileName } from "@/lib/pdf";

export function ReportPdfButton({ jobId, testid, compact }) {
  const [busy, setBusy] = useState(false);
  const run = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try {
      const { data } = await api.get(`/jobs/${jobId}`);
      downloadBlob(await buildReportPdf(data), reportFileName(data));
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button size="sm" variant="outline" className="rounded-full" onClick={run} disabled={busy} data-testid={testid} title="Scarica rapporto PDF">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileDown className="h-4 w-4" />}{compact ? " PDF" : " Scarica rapporto PDF"}
    </Button>
  );
}
